"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.prompt.title': '切换高级提示',
    'shortcuts.prompt.description': '启用或禁用高级提示结构和插槽系统',
};
